import React from 'react';
import { Bar } from 'react-chartjs-2';

function OffensesByDowChart({ data }) {
  // Ensure all days of the week are present in order
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const processedData = daysOfWeek.map(day => {
    const apiDay = data.find(d => d.day_name.trim() === day);
    return apiDay ? parseInt(apiDay.count, 10) : 0;
  });

  const chartData = {
    labels: daysOfWeek,
    datasets: [{
      label: 'Offenses by Day of Week',
      data: processedData,
      backgroundColor: 'rgba(202, 138, 4, 0.6)', // gold
      borderColor: 'rgba(202, 138, 4, 1)',
      borderWidth: 1,
    }],
  };

  return <Bar data={chartData} options={{ indexAxis: 'y', responsive: true }} />;
}

export default OffensesByDowChart;